export default {
    init() {
        let markers = document.getElementsByClassName('map-marker');
        let map = document.getElementsByClassName('map')[0];

        let that = this;
        if(markers.length > 0) {
            for(let i = 0; i < markers.length; i++) {
                let marker = markers[i];
                marker.addEventListener('click', function(e) {
                    this.nextElementSibling.classList.toggle('map-popover-visible');
                    that.close_popovers(this.nextElementSibling);
                    $(map).append(this.parentElement); 
                })
            }
        }

        this.calculate_marker_position();
        let map_marker_holders = document.getElementsByClassName('map-marker-holder');

        document.querySelector('body').addEventListener('click', function(e) {
            console.log('Found ' + map_marker_holders.length + " map marker holders");
            let target = $(e.target);
            for(let i = 0; i < map_marker_holders.length; i++) {
                if(map_marker_holders[i].contains(e.target)) {
                    console.log('clicked on map marker!')
                } else {
                    console.log("not the map marker!");
                    map_marker_holders[i].getElementsByClassName('map-popover-holder')[0].classList.remove('map-popover-visible')
                }
            }
        });
    }, 
    calculate_marker_position() {
        let that = this;
        that.popover_locations();

        // window.addEventListener('resize', function(e) {
        //     that.popover_locations();
        // })
    },
    popover_locations() {
        let map_markers = document.getElementsByClassName('map-marker-holder');
        if(map_markers.length > 0) {
            for(let i = 0; i < map_markers.length; i++) {
                let map_marker = map_markers[i];
                let marker_left = map_marker.style.left;
                let side = this.determine_side(marker_left, map_marker)
                
                if(side === 'left') {
                    let popover_holder = map_marker.getElementsByClassName('map-popover-holder')[0];
                    popover_holder.classList.add('map-popover-holder--right');
                    let arrow = popover_holder.getElementsByClassName('map-popover-arrow')[0];
                    arrow.innerHTML = '◀'
                }
            }
        }
    },
    determine_side(location, el) {
        let location_value = parseInt(location);
        console.log("Marker left: ", location_value);
        return (location_value < 50) ? 'left' : 'right';
    },
    close_popovers(el) {
        let popover = document.getElementsByClassName('map-popover-holder');
        if(popover.length > 0) {
            for(let i = 0; i < popover.length; i++) {
                console.log("Removing " + i)
                if(popover[i] != el) {
                    popover[i].classList.remove('map-popover-visible');
                }
            }
        }
    }
}